module.exports = __webpack_public_path__ + "img/20191017164513341.8685a796.jpg";